import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class SectorLocationService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }
  GetSectorLocation():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/SectorLocation/Get`);
  }

  DeleteSectorLocation(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/SectorLocation/Delete?id=${id}`);
  }

  CreateSectorLocation(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/SectorLocation/Create`,data);
  }
  UpdateSectorLocation(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/SectorLocation/Update`,data)
  }
}
